import {urlForUsers, urlForUser, urlForUsersRoles, urlForAddUser} from "@src/features/users/users-api-urls";
import type {GetAllUsersArgs, GetAllUsersResponse, GetUserArgs, GetUsersRolesArgs} from "@src/features/users/users-dtos";
import type {UserPublicInfo, AllUserRolesResponse} from "@src/features/users/users-models";
import {appApi} from "@src/integrations/redux/app-api";
import {HTTP_METHODS} from "@src/utils/network-constants";


export interface AddUserToSpaceRequest {
	spaceId: string;
	firstName: string;
	lastName: string;
	phoneCountryCode: string;
	phoneNumber: string;
	email: string;
	serviceType?: "timedShuttle";
	roleName?: "driver";
}

export interface AddUserToSpaceResponse {
	userId: string;
	// ...other fields from backend if any...
}

export const usersApi = appApi.injectEndpoints({
	tagTypes: ["UserRoles"],
	endpoints: (builder) => ({
		getAllUsers: builder.query<GetAllUsersResponse, GetAllUsersArgs>({
			query: (args) => ({
				url: urlForUsers(args.spaceId),
				method: HTTP_METHODS.GET
			})
		}),
		getUser: builder.query<UserPublicInfo, GetUserArgs>({
			query: (args) => ({
				url: urlForUser(args.spaceId, args.userId),
				method: HTTP_METHODS.GET
			})
		}),
		getUsersRoles: builder.query<AllUserRolesResponse, GetUsersRolesArgs>({
			query: ({ spaceId }) => ({
			url: urlForUsersRoles(spaceId),
			method: HTTP_METHODS.GET,
			}),
			providesTags: (_result, _error, { spaceId }) => [
			{ type: "UserRoles" as const, id: spaceId },
			],
		}),
		addUserToSpace: builder.mutation<
			AddUserToSpaceResponse,
			AddUserToSpaceRequest
		>({
			query: ({ spaceId, ...body }) => ({
				url: urlForAddUser(spaceId),
				method: HTTP_METHODS.POST,
				body,
			}),
		}),
		assignUserToRide: builder.mutation<
			AssignUserToRideResponse,
			AssignUserToRideRequest
		>({
			query: ({ spaceId, userId, rideId }) => ({
				// NOTE: adjust to your actual backend route
				url: `/spaces/${spaceId}/rides/${rideId}/assign-driver`,
				method: HTTP_METHODS.POST,
				body: { userId },
			}),
		}),
	}),
	overrideExisting: "throw"
});


export const {
	useGetAllUsersQuery,
	useGetUserQuery,
	useGetUsersRolesQuery,
	useAddUserToSpaceMutation,
	useAssignUserToRideMutation,
} = usersApi;